import { render, staticRenderFns } from "./ReviseSchemeDeadline.vue?vue&type=template&id=1b39d1d6"
import script from "./ReviseSchemeDeadline.vue?vue&type=script&lang=js"
export * from "./ReviseSchemeDeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports